import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@ui/lib/utils.js';

export { default as PSwitch, type PSwitchProps } from './PSwitch.vue';

export const pSwitchVariants = cva('group', {
    variants: {
        variant: {
            default: cn(
                'rounded-full',
                'h-[1.15rem]',
                'w-8',
                'data-[state=checked]:bg-surface-primary',
                'data-[state=unchecked]:bg-surface-accent-2',
                'border',
                'border-transparent',
            ),
            square: cn('rounded-sm', 'h-[2rem]', 'bg-white', 'border', 'border-black/5'),
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const pSwitchThumbVariants = cva('', {
    variants: {
        variant: {
            default:
                'rounded-full size-4 bg-white data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0',
            square: 'rounded-sm size-8 bg-black/5 data-[state=checked]:translate-x-[100%] data-[state=unchecked]:translate-x-0',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export type PSwitchVariants = VariantProps<typeof pSwitchVariants>;
export type PSwitchThumbVariants = VariantProps<typeof pSwitchThumbVariants>;
